export const compareObjects = (obj1: any, obj2: any): boolean => {
  const obj1String = JSON.stringify(obj1);
  const obj2String = JSON.stringify(obj2);
  return obj1String === obj2String;
};
